import AsyncApi from './containers/AsyncApi/AsyncApi';
export default AsyncApi;
//# sourceMappingURL=index.js.map